module.exports = __webpack_public_path__ + "static/media/desert-crossroads-off.df87be0b.png";